import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../components/Login.vue';
import LoginAuto from '../components/LoginAuto.vue';
import Gpt from '../components/Gpt.vue';
import LiographicalLink from '../components/LiographicalLink.vue';
import Nav from '../components/Nav.vue';
  import CloudIconLibrary from '../components/dashboard/CloudIconLibrary.vue';
  import DialectSquare from '../components/dashboard/DialectSquare.vue';
  import MyProject from '../components/dashboard/MyProject.vue';
  import RecycleBin from '../components/dashboard/RecycleBin.vue';
  import DataView from '../components/dashboard/DataView.vue';
  import Dialogues from '../components/dashboard/Dialogues.vue';
  import ScriptSquare from '../components/dashboard/ScriptSquare.vue';
  import NewSpeak from '../components/myproject/NewSpeak.vue';
  import SimulatedDialogue from '../components/myproject/SimulatedDialogue.vue';
  import Communication from '../components/myproject/Communication.vue';
  import ProDetail from '../components/dashboard/ProDetail.vue';
  import GptDetail from '../components/dashboard/GptDetail.vue';

import Statistics from '../components/statistics/Statistics.vue';
  import StatisticsToday from '../components/statistics/StatisticsToday.vue';
  import HistoricalReport from '../components/statistics/HistoricalReport.vue';
  import PathListen from '../components/statistics/PathListen.vue';

import Account from '../components/Account.vue';
  import AccountInfo from '../components/account/AccountInfo.vue';
  import ValueService from '../components/account/ValueService.vue';
  import MyAccount from '../components/account/MyAccount.vue';
  import PathManage from '../components/account/PathManage.vue';
  import SourcePackage from '../components/account/SourcePackage.vue';

import PublicPart from '../components/myproject/PublicPart.vue';
  import EditLanguage from '../components/myproject/EditLanguage.vue';
  import IntentionTrain from '../components/myproject/IntentionTrain.vue';
  import ProjectLines from '../components/myproject/ProjectLines.vue';
  import DiscreteNode from '../components/myproject/DiscreteNode.vue';
  import DiscreteBranch from '../components/myproject/DiscreteBranch.vue';

import ChannelMenu from '../components/channel/ChannelMenu.vue';
  import ChannelAccess from '../components/channel/ChannelAccess.vue';
  import CallApi from '../components/channel/CallApi.vue';
  import WaitingDevelop from '../components/channel/WaitingDevelop.vue';

import Chat from '../components/website/Chat.vue';
import { sessionData } from "../storage/storage";

Vue.use(VueRouter)
const routes = [
    { path: '/', redirect: '/Login' },
    { path: '/Login', component: Login },
    { path: '/LoginAuto', component: LoginAuto },
    { 
      path: '/Gpt', 
      component: Gpt,
      meta: {
        requireAuth: true,  
      } 
    },
    { 
      path: '/LiographicalLink', 
      component: LiographicalLink,
      meta: {
        requireAuth: false,  
      } 
    },
    { path: '/Nav', 
      component: Nav,
      children: [
        { path: '/', redirect: 'MyProject' },
        { 
          path: '/CloudIconLibrary',
          component: CloudIconLibrary,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: '/DialectSquare', 
          component: DialectSquare,
          meta: {
            requireAuth: false,  
          }  
        },
        { 
          path: '/MyProject', 
          component: MyProject,
          meta: {
            requireAuth: true,  
          } 
        },
        { 
          path: '/RecycleBin', 
          component: RecycleBin,
          meta: {
            requireAuth: true,  
          } 
        },
        { 
          path: '/ProDetail', 
          component: ProDetail,
          meta: {
            requireAuth: true,  
          } 
        },
        { 
          path: '/GptDetail', 
          component: GptDetail,
          meta: {
            requireAuth: true,  
          } 
        },
        { 
          path: '/DataView', 
          component: DataView,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: '/ScriptSquare', 
          component: ScriptSquare,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: '/Dialogues', 
          component: Dialogues,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: '/StatisticsToday', 
          component: StatisticsToday,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: '/HistoricalReport', 
          component: HistoricalReport,
          meta: {
            requireAuth: true,  
          }  
        },
        { path: '/Account', 
          component: Account,
          children: [
            { path: '/', redirect: 'AccountInfo' },
            { 
              path: 'AccountInfo', 
              component: AccountInfo,
              meta: {
                requireAuth: true,  
              }  
            },
            { 
              path: 'ValueService', 
              component: ValueService,
              meta: {
                requireAuth: true,  
              }  
            },
            { 
              path: 'MyAccount',
              component: MyAccount,
              meta: {
                requireAuth: true,  
              }  
            },
            { 
              path: 'PathManage', 
              component: PathManage,
              meta: {
                requireAuth: true,  
              }  
            },
            { 
              path: 'SourcePackage', 
              component: SourcePackage,
              meta: {
                requireAuth: true,  
              }  
            },
          ]
        },
        
        { 
          path: '/NewSpeak', 
          component: NewSpeak,
          meta: {
            requireAuth: true,  
          }  
        },
        // { 
        //   path: '/SimulatedDialogue', 
        //   component: SimulatedDialogue,
        //   meta: {
        //     requireAuth: false,  
        //   }  
        // },
        // { 
        //   path: '/Communication', 
        //   component: Communication,
        //   meta: {
        //     requireAuth: false,  
        //   }  
        // },

        {
          path: '/Statistics',
          component:Statistics,
          children: [
            { path: '/', redirect: 'StatisticsToday' },
            { 
              path: 'StatisticsToday', 
              component: StatisticsToday, 
              meta: {
                requireAuth: true,  
              } 
            },
            { 
              path: 'HistoricalReport', 
              component: HistoricalReport,
              meta: {
                requireAuth: true,  
              }  
            },
          ]
        },
        {
          path: '/ChannelMenu',
          component:ChannelMenu,
          children: [
            { path: '/', redirect: 'ChannelAccess' },
            { 
              path: 'ChannelAccess', 
              component: ChannelAccess, 
              meta: {
                requireAuth: true,  
              } 
            },
            { 
              path: 'CallApi', 
              component: CallApi, 
              meta: {
                requireAuth: true,  
              } 
            },
            { 
              path: 'WaitingDevelop', 
              component: WaitingDevelop, 
              meta: {
                requireAuth: true,  
              } 
            },
          ]
        },
      ]
    },
    {
      path: '/PublicPart',
      component:PublicPart,
      children: [
        { path: '/', redirect: 'EditLanguage' },
        { 
          path: 'EditLanguage', 
          component: EditLanguage, 
          meta: {
            requireAuth: true,  
          } 
        },
        { 
          path: 'IntentionTrain', 
          component: IntentionTrain,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: 'ProjectLines', 
          component: ProjectLines,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: 'DiscreteNode', 
          component: DiscreteNode,
          meta: {
            requireAuth: true,  
          }  
        },
        { 
          path: 'DiscreteBranch', 
          component: DiscreteBranch,
          meta: {
            requireAuth: true,  
          }  
        },
      ]
    },
    { 
      path: '/Chat', 
      component: Chat,
      meta: {
        requireAuth: false,  
      }  
    },
    { 
      path: '/PathListen', 
      component: PathListen,
      meta: {
        requireAuth: false,  
      }  
    },
    { 
      path: '/Communication', 
      component: Communication,
      meta: {
        requireAuth: false,  
      }  
    },
    { 
      path: '/SimulatedDialogue', 
      component: SimulatedDialogue,
      meta: {
        requireAuth: false,  
      }  
    },
  ]
const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (sessionData('get','token')) {  // 获取当前的token是否存在
      next();
    } else {
      next('/login')
    }
  }else { // 如果不需要权限校验，直接进入路由界面
    next();
  }
});
export default router;
